import React from "react";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./index.scss";

function VLFModal(props) {
	const {
		maxWidth = "sm",
		fullWidth = true,
		open,
		title,
		content,
		confirm,
		close,
		confirmLabel = "Salva",
		cancelLabel = "Annulla",
		disabled = false,
		paperClassName = "",
	} = props;

	const showHeader = Boolean(title) || Boolean(close);

	return (
		<Dialog
			maxWidth={maxWidth}
			fullWidth={fullWidth}
			open={open}
			onClose={close}
			PaperProps={{className: `vlf-modal__paper ${paperClassName}`.trim()}}
		>
			{showHeader && (
				<DialogTitle className="vlf-modal__title">
					{title && <span className="vlf-modal__title-text">{title}</span>}
					{close && (
						<IconButton
							className="vlf-modal__close"
							size="small"
							onClick={close}
							aria-label="chiudi"
						>
							<CloseIcon fontSize="small" />
						</IconButton>
					)}
				</DialogTitle>
			)}
			<DialogContent className="vlf-modal__content dialog-container">
				{content}
			</DialogContent>
			<DialogActions className="vlf-modal__actions">
				{close ? (
					<Button
						onClick={close}
						color="error"
						variant="outlined"
						className="vlf-modal__btn vlf-modal__btn--secondary"
					>
						{cancelLabel}
					</Button>
				) : null}
				{confirm ? (
					<Button
						onClick={confirm}
						disabled={disabled}
						color="primary"
						variant="contained"
						className="vlf-modal__btn vlf-modal__btn--primary"
					>
						{confirmLabel}
					</Button>
				) : null}
			</DialogActions>
		</Dialog>
	);
}

export default VLFModal;
